export default __webpack_public_path__ + "static/media/hpyx.44c30bd5.jpg";